<template>
  <div>
    <!-- New styling category name -->
    <p 
      v-if="categoryName && useNewStyling" 
      class="vw-category-name vw-category-name-new mb-2 cursor-pointer"
      @click="toggleExpanded()"
    >
      <span class="flex items-center justify-between">
        {{ categoryName }}
        <img 
          src="@/assets/orderTest/order-page/order-test-panel/arrow_drop_down_grey.svg" 
          alt="expand icon" 
          :class="['category-expand-icon', { 'rotate-180': isExpanded }]"
        />
      </span>
    </p>
    <!-- Old styling category name -->
    <p 
      v-if="categoryName && !useNewStyling" 
      class="vw-category-name mb-2"
    >
      {{ categoryName }} ({{ testNodeList.length }})
    </p>
    <transition name="expand-collapse">
      <div v-if="!useNewStyling || !categoryName || isExpanded" class="test-cards-container">
        <TestCard
          v-for="testGroupNode in testNodeList"
          :key="testGroupNode.id"
          :test-group-node="testGroupNode"
          :is-show-expand="testGroupNode.descendants.length > 0"
          :select-prop="selectProp"
          :is-not-allowed-select-prop="isNotAllowedSelectProp"
          :order-test-support-obj="orderTestSupportObj"
          class="mb-3"
        />
      </div>
    </transition>
</div>
</template>

<script>
import TestCard from "../../TestCard.vue";
export default {
  components: {
    TestCard
  },
  props: {
    categoryName: {
      type: String,
      default: ""
    },
    useNewStyling: {
      type: Boolean,
      default: false
    },
    testNodeList: {
      type: Array,
      default: () => []
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },    
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isExpanded: true 
    }
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    }
  }
}
</script>

<style>
.vw-category-name {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.1px;
  color: #f06539;
}

.vw-category-name-new {
  font-family: 'Roboto', sans-serif;
  color: #979797;
}

.category-expand-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

.rotate-180 {
  transform: rotate(180deg);
}

.test-cards-container {
  overflow: hidden;
}

.expand-collapse-enter-active {
  transition: all 0.3s ease;
  transform: translateY(0);
  opacity: 1;
}

.expand-collapse-leave-active {
  transition: all 0.3s ease;
  transform: translateY(0);
  opacity: 1;
}

.expand-collapse-enter-from {
  transform: translateY(-20px);
  opacity: 0;
}

.expand-collapse-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>